import _ from 'lodash';

const getProgressPercentage = (currentStep, maxStep) => {
	return Math.round(currentStep / maxStep * 100);
};

export const getGroupProgressTableData = (users, activityInfo, progressPerActivity) => {
	const studentCompare = (a, b) => b.percentage - a.percentage;
	const tableData = Object.values(activityInfo).map(
		({ activityId, name: activityName, maxStep }) => {
			const activityProgress = progressPerActivity[activityId];
			const studentsProgress = activityProgress.map(({ userId, currentStep }) => {
				const user = users[userId];
				const percentage = getProgressPercentage(currentStep, maxStep);
				return { ...user, percentage };
			});
			studentsProgress.sort(studentCompare);
			const activityStatus = { activityName, studentsProgress };
			return activityStatus;
		}
	);
	return tableData;
};

export const getStudentProgressTableData = (activityInfo, progressPerActivity) => {
	return Object.values(activityInfo)
		.map(({ activityId, name: activityName, maxStep }) => {
			const activityProgress = progressPerActivity[activityId];
			const percentage = getProgressPercentage(
				activityProgress && activityProgress[0].currentStep,
				maxStep
			);
			const activityStatus = { activityName, percentage };
			return activityStatus;
		})
		.filter(activityStatus => {
			return !_.isNil(activityStatus.percentage);
		});
};
